import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Api } from 'services/api';
import { useConfirmation, useSendCodeTo } from 'hooks/api/login';
import { useNavigate } from 'hooks/routes';
import { protectPhoneInState } from 'utils/typeGuards';
import CodeVerification from 'components/CodeVerification';
import { showSuccessToast } from 'components/Toast';
import VerifyResendCode from 'components/VerifyResendCode';
import Loader from 'components/Loader';
import messages from './Verify.messages';
import styles from './Verify.module.css';

const Verify = (): JSX.Element => {
  const { state } = useLocation();
  const { toLogin } = useNavigate();

  const phone = protectPhoneInState(state) ? state.phone : null;

  useEffect(() => {
    if (!Api.axios.defaults.headers.common.Authorization || !phone) {
      toLogin();
    }
  }, []);

  const { mutateAsync: confirmation, isLoading, isError } = useConfirmation();
  const { mutateAsync: sendCodeTo } = useSendCodeTo();

  const confirm = async (code: string) => {
    await confirmation({ code: code });
  };

  const resendCode = async (): Promise<void> => {
    await sendCodeTo();
    showSuccessToast(messages.successSendCode);
  };

  return (
    <div className={styles.verify}>
      <h1 className={styles.verify__title}>{messages.title}</h1>
      <p className={styles.verify__text}>
        {messages.text}
        <span>{phone}</span>
      </p>
      <CodeVerification
        codeLength={4}
        onChange={confirm}
        loading={isLoading}
        isError={isError}
      />
      <div className={styles.verify__loaderWrapper}>
        {isLoading && <Loader className={styles.verify__loader} />}
      </div>
      <VerifyResendCode resendCode={resendCode} />
    </div>
  );
};

export default Verify;
